export default __webpack_public_path__ + "static/media/1957-mobile.88eee8d4.jpg";